import { Link } from "react-router-dom";
import { PROFILE_EDIT_PATH, type MissingRequiredSummary } from "./outreachCopy";

/**
 * Why a card has nothing to copy — the step cannot be written for this buyer
 * yet (no listing picked, no submission on file, …). The reason is the
 * server's, so the card never guesses at it.
 */
export function UnavailableNotice({ reason, testId }: { reason: string; testId: string }) {
  return (
    <p
      className="m-0 rounded-md border border-border-light bg-white-warm px-space-3 py-space-2 text-small text-onyx"
      data-testid={testId}
    >
      {reason}
    </p>
  );
}

/**
 * A required field is missing from what this card would copy (G11), so the
 * card's copy is disabled and LOG will not log this channel.
 *
 * <p>The specialist's own name, phone and email are fixed on THEIR profile,
 * not on this buyer, so that sentence is a door to the profile page. Anything
 * else required is named by the label the Pulled-from card uses, where its own
 * door is.</p>
 */
export function MissingRequiredNotice({
  summary,
  testId,
}: {
  summary: MissingRequiredSummary;
  testId: string;
}) {
  if (!summary.profileNouns && summary.otherLabels.length === 0) return null;
  return (
    <div
      role="status"
      className="grid gap-space-1 rounded-md bg-status-warning/15 px-space-3 py-space-2 text-small text-status-warning-ink"
      data-testid={testId}
    >
      {summary.profileNouns && (
        <p className="m-0">
          <Link to={PROFILE_EDIT_PATH} className="font-semibold underline underline-offset-2">
            Add your {summary.profileNouns} to your profile
          </Link>{" "}
          — this can&apos;t be copied until it&apos;s filled in.
        </p>
      )}
      {summary.otherLabels.length > 0 && (
        <p className="m-0">
          Missing {summary.otherLabels.join(", ")} — this can&apos;t be copied until it&apos;s
          filled in.
        </p>
      )}
    </div>
  );
}
